import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

// Mobile header styles (Detail/Navigation pattern)
export const mobileHeader = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const headerContainer = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  position: relative;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  
  &:hover {
    opacity: 0.8;
  }
`

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const headerTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const contentWrapper = css`
  ${MQ.TABLETS} {
    padding-top: 50px; /* Reduced space for tighter spacing with header */
  }
  position: relative;
  z-index: 1;
`

export const panel = css`
  height: 80vh;
  position: relative;
  z-index: 1;
  
  ${MQ.TABLETS} {
    height: 100vh;
    background-color: ${colors.black100};
    padding-bottom: 100px; /* Space for bottom navigation */
  }
`

export const title = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  ${MQ.TABLETS} {
    display: none; /* Hide desktop title on mobile - use header instead */
  }
`

export const pageWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding: ${spacing(4)};
  position: relative;
  z-index: 1;
`

export const formContent = css`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`

export const row = css`
  min-height: ${unit * 8}px;
  position: relative;
  z-index: 1;
  
  & label {
    width: 100%;
    display: block;
    margin-bottom: ${spacing(0.75)};
    font-weight: 300;
    margin-left: ${spacing(2)};
  }
  
  /* Make all regular FormInput components 40px height */
  & input[type="text"],
  & input[type="email"],
  & input[type="tel"],
  & input {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding: 0 ${spacing(2)} !important;
    box-sizing: border-box !important;
    font-size: 13px !important;
  }
  
  /* Target FormInput component containers */
  & > div:last-child,
  & > div:not(:first-child) {
    & > div {
      height: 40px !important;
      min-height: 40px !important;
      max-height: 40px !important;
      
      & input {
        height: 40px !important;
        min-height: 40px !important;
        max-height: 40px !important;
        padding: 0 ${spacing(2)} !important;
        box-sizing: border-box !important;
        font-size: 13px !important;
      }
    }
  }
`

export const saveButton = css`
  width: 100%;
  height: 36px;
`

export const buttonText = css`
  color: #000000 !important;
  font-weight: 700;
  font-size: 14px;
`